import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { useEffect } from "react";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./i18n";

function HtmlLanguageSync() {
  const { i18n: activeI18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = activeI18n.language.startsWith('ru') ? 'ru' : 'kk';
  }, [activeI18n.language]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <HtmlLanguageSync />
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
